import { getAllAccounts, getCurrentAccount } from '../auth/service';
import { selectors } from '../store/Auth';
import { AccountInfo } from '@azure/msal-browser';
import { useSelector } from 'react-redux';
import { UserProfile } from '../models';

export default function useAuth(): { currentAccount: AccountInfo | null; otherAccounts: AccountInfo[]; profile: UserProfile | null } {
	const profile = useSelector(selectors.getProfile);

	try {
		const allAccounts = getAllAccounts();
		const currentAccount = getCurrentAccount();

		return {
			currentAccount: getCurrentAccount(),
			otherAccounts: allAccounts.filter(acct => currentAccount && acct.username !== currentAccount.username),
			profile: {
				displayName: profile ? profile.displayName : '',
				id: profile ? profile.id : '',
				uniqueName: '',
				firstName: profile ? profile.firstName : '',
				jobTitle: profile ? profile.jobTitle : '',
				lastName: profile ? profile.lastName : ''
			}
		};
	} catch (ex) {
		console.error(ex);
		return {
			currentAccount: null,
			otherAccounts: [],
			profile: null
		};
	}
}
